
import React, { lazy } from 'react';

const authRoute = [
  {
    key: "signIn",
    path: `/sign-in`,
    component: lazy(() => import("views/auth/SignIn")),
    authority: [],
  },
  {
    key: "signUp",
    path: `/sign-up`,
    component: lazy(() => import("views/auth/SignUp")),
    authority: [],
  },
  {
    key: "inviteSignUp",
    path: `/invite/sign-up`,
    component: lazy(() => import("views/auth/inviteSignUp")),
    authority: [],
  },
  {
    key: "forgotPassword",
    path: `/forgot-password`,
    component: lazy(() => import("views/auth/ForgotPassword")),
    authority: [],
  },
  {
    key: "resetPassword",
    path: `/password-reset/*`,
    component: lazy(() => import("views/auth/ResetPassword")),
    authority: [],
  },
  {
    key: "VerifyEmail",
    path: `/verify`,
    component: lazy(() => import("views/auth/Verify")),
    authority: [],
  },
  {
    key: "ecommerce",
    path: "/autogon-marketplace",
    component: lazy(() => import("views/Ecommerce")),
    authority: [],
  },
  {
    key: "ecommerce",
    path: "/autogon-marketplace-details/:id",
    component: lazy(() => import("views/Ecommerce/Product")),
    authority: [],
  },
];

export default authRoute